module.exports = __webpack_public_path__ + "img/little-asymmetry-right.69550792.svg";